import { render } from "./Arrears.vue?vue&type=template&id=61beddcf"
import script from "./Arrears.vue?vue&type=script&lang=js"
export * from "./Arrears.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chanks\\Documents\\Development\\quitrent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__